<template>
    <div class="h-100 d-flex flex-column">
        <v-toolbar class="shadow-none" content-class="h-auto">
            <div class="d-flex align-items-center">
                <v-toolbar-title class="size-16 dark-text">{{ $t("res_MenuItem_ManageViwerStamp") }}</v-toolbar-title>
            </div>
            <v-spacer></v-spacer>
        </v-toolbar>

        <div class="border-top p-4">
            <!-- <p class="text-md lh-md">{{ $t("res_Msgs_ManageStructureStampDesc") }}</p> -->
            <div> 
                <v-btn @click="AddNewViewerStampClick()" color="primary">
                    {{ $t("res_ButtonText_AddNewViewerStamp") }}
                </v-btn>
            </div>
        </div>

        <p v-if="stampItems.length == 0" class="font-weight-bold text-md lh-md" style="margin: 25px;">{{ $t("res_Msgs_NoViewerStamp") }}</p>
        <div class="stamp-items-wrapper" v-else>
                <div v-for="(item, index) in stampItems" :key="item.id" style="margin: 25px !important;">
                    <v-img max-width="150" max-height="100" :src="'data:image/png;base64,'+item.stampImage"></v-img>
                    <v-btn color="error" class="mt-2" style="width: 100%;" @click="removeStamp(item.id)">{{ $t("res_ButtonText_Delete") }}</v-btn>
                </div>
        </div> 
        
                        
        <v-dialog v-model="addStructureStampDialog" content-class="dialog bg-white w-40" scrollable>
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">{{ $t("res_Title_AddViewerStamp") }}</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="addStructureStampDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <div class="d-flex flex-column overflow-auto h-100">
                    <div class="p-4 flex-grow-1 overflow-auto">
                        <div class="mb-3-rem">
                            <v-label>{{ $t("res_Label_StampName") }} <span>*</span></v-label>
                            <v-text-field solo v-model="uploadedStamp.name" :rules="[rules.required]"></v-text-field>
                        </div>
                        <div class="mb-3-rem">
                            <v-label>{{ $t("res_Label_StampDescription") }}</v-label>
                            <v-textarea v-model="uploadedStamp.description" label="" class="light-bg" :placeholder="$t('res_Label_defaultTextValue')"></v-textarea>
                        </div>
                        <div class="mb-3-rem">
                            <v-label>{{ $t("res_Label_StampImage") }} <span>*</span></v-label>
                            <v-file-input accept=".jpg,.jpeg,.png" v-model="uploadedStamp.imageData" @change="onUploadedStampChange" solo prepend-icon=""></v-file-input>
                            <v-img class="mt-4" v-if="previewStamp != '#'" :src="previewStamp" max-height="150" max-width="150"></v-img>
                        </div>
                    </div>
                    <v-card-actions class="top-shadow gap-3">
                        <v-btn class="light-blue flex-1"  @click="addStructureStampDialog = false">{{$t("res_ButtonText_Cancel")}}</v-btn>
                        <v-btn 
                        @click="checkFormStamp"
                        class="primary flex-1">{{$t("res_ButtonText_Save")}}</v-btn>
                    </v-card-actions>
                </div>
            </v-card>
        </v-dialog>
                        
             
    </div>

</template>

<script>
import axios from "axios";
import constants from "@/assets/js/constants";
import Multiselect from "vue-multiselect";
export default {
	name: "ManageStructureStamp",
	components: { Multiselect },props: {
		structure_id: Number,
	},
	  data: function () {
            return {
                uploadedStamp: {
                    name: '',
                    description: '',
                    imageData: null
                },
                previewStamp: '#',
                addStructureStampDialog: false,
                drawer: false,
                items: [],
                stampItems:[],
                errors: [],
                menuDialog: false,
                menuLogDialog: false,
                menuStampDialog: false,
                freeHandWritingColor: '#0000FF',
                chooseFreeHandWritingColor: false,
                obj_: '',
                Name: null,
                StampName: null,
                Description: null,
                StampDescription: null,
                imageStampData: null,
                imageData: null,
                requiredData: null,
                rules: {
                    required: (value) => !!value || "Required."
                },
                obj: [
                    { value: "auto", text: "Automatic Zoom" },
                    { value: "page-actual", text: "Actual Size" },
                    { value: "page-fit", text: "Page Fit" },
                    { value: "page-width", text: "Page Width" },
                    { value: "0.5", text: "50%" },
                    { value: "0.75", text: "75%" },
                    { value: "1", text: "100%" },
                    { value: "1.25", text: "125%" },
                    { value: "1.5", text: "150%" },
                    { value: "2", text: "200%" },
                    { value: "3", text: "300%" },
                    { value: "4", text: "400%" }
                ],
                search: '',
                itemst: [],
                headers: [
                    { text: 'Action', value: 'Action' },
                    { text: 'User', value: 'UserName' },
                    { text: 'Date', value: 'Date' },
                ],
                page: 1,
                itemsPerPage: 10,
                totalRecords: null,
                pageCount: null,
                perPageChoices: [
                    { text: '5', value: 5 },
                    { text: '10', value: 10 },
                    { text: '20', value: 20 },
                ],
                all_attachments_count: 0,
                all_attachments: [],
                all_versions: [],
                current_version: '',
                tooltip1: 'this is a test',
                snackbar_show: false,
                snackbar_text: '',
                snackbar_type: '',

                informationDialog: false,
                information_heading: '',
                information_text: '',
                information_continueHandler: null,
                information_cancelHandler: null,
                showLoader: false,
                pageMode: 'view',
                defaultScale: '',
                showNextAttachmentBtn: false,
                showPreviousAttachmentBtn: false,
                showAttachmentName: false,
                StructureStamps: [],
                document: {
                    id: 0,
                    name: '',
                    extension: '',
                },
                showStamps: false,
                qrCodeImageUrl: '',
            }
        },
        beforeMount() {
            window.translate = this.translate;
        },
        watch: {
            structure_id() {
                
                this.getUserStamps()
            },
            drawer() {
                console.log(this.drawer)
            },
            all_attachments() {
                this.setAttachmentData();
            },
            menuLogDialog(newVal, oldVal) {
                if (newVal && this.requiredData === null) {
                    this.GetViewerLogs(newVal);
                }
            },
        },
        updated: function () 
        {
            // if (document.getElementById("hd_IsShowStamps").value=='true')
            //     this.showStamps=true;
            // else
            //     this.showStamps=false;
        },
        mounted() 
        {
            this.getUserStamps();
        },
        methods:
        {
            AddNewViewerStampClick()
            {
                this.addStructureStampDialog = true;
            },
            createImage(file) {
                this.isOrginalStamp = false;
                const reader = new FileReader();
                reader.onload = e => {
                    this.previewStamp = e.target.result;
                };
                reader.readAsDataURL(file);
            },
            isFileTypeValid() 
            {
                const file = this.uploadedStamp.imageData;
                return file && file.type.startsWith('image/');
            },
            onUploadedStampChange()
            {
                if(this.uploadedStamp.imageData == null || this.uploadedStamp.imageData == undefined)
                {
                    this.previewStamp = '#';
                    return
                }
                const isFileTypeValid = this.isFileTypeValid();
                if(isFileTypeValid == false)
                {
                    window.showAlert(this.$t("res_Msgs_FileMustBeImage"), "warning");
                    this.uploadedStamp.imageData = {};
                    this.previewStamp = '#';
                    return;
                }
                if(this.uploadedStamp.imageData.size == 0)
                    return
                this.createImage(this.uploadedStamp.imageData);
            },
            async getUserSignatures() 
            {
                var headers = { 'Authorization': 'Bearer ' + sessionStorage.getItem('jwt_token') }

                axios.get(constants.ViewerActionUrl + 'GetUserSignatures', { headers: headers })
                    .then(res => 
                    {
                        this.items = res.data;
                    })
                    .catch(error => { console.log(error) })
            },
            async getUserStamps() 
            {
                var headers = { 'Authorization': 'Bearer ' + sessionStorage.getItem('jwt_token') }

                axios.get(constants.ViewerActionUrl + 'GetUserStamps?structureId='+this.structure_id+"&fromUserManagement="+true, { headers: headers })
                    .then(res => 
                    {
                        this.stampItems = res.data;
                    })
                    .catch(error => { console.log(error) })
            },
            SignOnFile: function (event) {

                document.getElementById("hd_SignatureId").value = event.currentTarget.getAttribute('SignId');
                document.getElementById("hd_AnnotationIndex").value = 7;
                document.getElementById("hd_TypeSign").value = event.currentTarget.getAttribute('TypeSign');
                document.getElementById("hd_SignaturePin").value = event.currentTarget.getAttribute('gupcxidsn');

                document.getElementById('hd_AutomaticSignatureImageName').value = 'data:image/png;base64,' + event.currentTarget.getAttribute('imgbyte');

            },
            StampOnFile: function (event) 
            {
	            document.getElementById("hd_StampId").value = event.currentTarget.getAttribute('StampId');
	            document.getElementById("hd_AnnotationIndex").value = 1;
	            document.getElementById("hd_TypeSign").value = event.currentTarget.getAttribute('TypeSign');
	            document.getElementById("hd_SignaturePin").value = event.currentTarget.getAttribute('gupcxidsn');
	            document.getElementById('hd_SelectedAnnotationName').value = 'data:image/png;base64,' + event.currentTarget.getAttribute('imgbyte');
            },
            QrCodeOnFile: function (event)
            {
                //document.getElementById("hd_TypeSign").value = event.currentTarget.getAttribute('TypeSign');
                document.getElementById("hd_AnnotationIndex").value = 9;
                document.getElementById('hd_BarcodeImageName').value = this.qrCodeImageUrl;
            },
            checkForm(e) {
                e.preventDefault();
                this.errors = [];
                if (this.Name === null) {
                    this.errors.push("Signature name is required.");
                } else {
                    if (this.imageData == null) {
                        this.errors.push("Signature image is required.");
                    } else {
                        var headers = {
                            'Authorization': 'Bearer ' + getUrlParameter('token')
                        }
                        var actionnn = constants.ViewerActionUrl + "SaveUserSignature";

                        var dataForm = {};
                        dataForm.name = this.Name;
                        dataForm.description = this.Description;
                        dataForm.imageData = this.imageData;
						dataForm.structureId = this.structure_id;

                        var res = PostSignature(headers, actionnn, dataForm);
                        console.log(this.items);
                        this.items = [];
                        console.log(this.items);
                        this.items = res;

                        this.Name = null;
                        this.Description = null;
                        this.imageData = null;
                    document.getElementById('#sigName').value="";
                        document.getElementById('#sigDesc').value="";
                        document.getElementById('.file-input').value=""
                        document.getElementById('.image-input').value="";
                    }
                }
            },
            checkFormStamp() {
                if (this.uploadedStamp.name == null || this.uploadedStamp.name == '') {
                    window.showAlert('res_Msgs_StampNameIsRequired', 'error');
                    return;
                }
                if (this.uploadedStamp.imageData == null) {
                    window.showAlert('res_Msgs_StampImageIsRequired', 'error');
                    return;
                }

                var headers = { 'Authorization': 'Bearer ' + sessionStorage.getItem('jwt_token') };

                const reader = new FileReader();
                reader.readAsDataURL(this.uploadedStamp.imageData);
                reader.onload = () => {
                    const base64ImageData = reader.result;

                    var requestBody = {
                        name: this.uploadedStamp.name,
                        description: this.uploadedStamp.description,
                        imageData: base64ImageData,
                        structureId: this.structure_id,
                        fromUserManagement: true
                    };

                    window.showLoading();
                    axios.post(constants.ViewerActionUrl + 'SaveUserStamp', requestBody, { headers: headers })
                        .then(res => {
                            window.showAlert('res_Msgs_StampUploaded', 'success');
                            this.stampItems = res.data;
                            this.uploadedStamp = {
                                name: '',
                                description: '',
                                imageData: null
                            };
                            this.previewStamp = '#';
                            this.addStructureStampDialog = false;
                        })
                        .catch(error => {
                            console.log(error);
                            window.showAlert('res_Msgs_ErrorOccured', 'error');
                        })
                        .finally(() => window.hideLoading());
                };

                reader.onerror = () => {
                    console.log("reader error => ", reader.error);
                    window.showAlert('res_Msgs_ErrorOccured', 'error');
                };
            },
            CreateQrCode()
            {
                if(getUrlParameter('documentId') !=''){
                    axios.post(constants.ViewerActionUrl + 'CreateQrcode?documentId='+getUrlParameter('documentId') , { headers: headers })
                        .then(res =>
                            {   
                                if(res.data != null && res.data !='' ){
                                    this.qrCodeImageUrl =res.data
                                }
                            }).catch(error => { console.log(error) })
                }

            },
            removeSignature(id) 
            {
                RemoveUserSignature(id);
            },
            removeStamp(id) {
                window.showInformation('res_Msgs_Confirmation', window.translate("res_Msgs_DeleteStampConfirmation"), () => {
                    window.showLoading();
                    var headers = { 'Authorization': 'Bearer ' + sessionStorage.getItem('jwt_token') };

                    axios.get(constants.ViewerActionUrl + "DeleteUserStamp?Id=" + id, { headers: headers })
                        .then(res => {
                            if (res.data == true) {
                                window.showAlert('res_Msgs_StampDeleted', 'success');
                                this.getUserStamps();
                            } else {
                                window.showAlert('res_Msgs_ErrorOccured', 'error');
                            }
                        })
                        .catch(err => {
                            console.error(err);
                            window.showAlert('res_Msgs_ErrorOccured', 'error');
                        })
                        .finally(() => window.hideLoading());
                }, () => {});
            },
            setAttachmentData() {
                if (this.all_attachments.length > 1) {
                    let currentAttacmentId = getUrlParameter('id');

                    const attachmentIndex = this.all_attachments.findIndex(el => el.id == currentAttacmentId);

                    if (attachmentIndex < this.all_attachments.length - 1) {
                        this.showNextAttachmentBtn = true;
                    }

                    if (attachmentIndex > 0) {
                        this.showPreviousAttachmentBtn = true;
                    }

                    this.document = this.all_attachments[attachmentIndex];
                }
                else {
                    this.document = this.all_attachments[0];
                }

                this.showAttachmentName = true;

                var context = this;
                setTimeout(function () {
                    context.showAttachmentName = false;
                }, 3000);
            },
            loadNextPrevAttachment(isNext) {

                let currentAttacmentId = getUrlParameter('id');
                let attachmentIndex = this.all_attachments.findIndex(el => el.id == currentAttacmentId);

                if (isNext)
                    attachmentIndex++;
                else
                    attachmentIndex--;
                loadAttachment({ id: this.all_attachments[attachmentIndex].id });
            },
            
            loadFirstAttachment(){
                let currentAttacmentId = getUrlParameter('id');
               let attachmentIndex = this.all_attachments.findIndex(el => el.id == currentAttacmentId);
               if(attachmentIndex>0)
                     loadAttachment({ id: this.all_attachments[0].id });
            },
            loadAttachment(item) 
            {
                loadAttachment(item)
            },
            loadAttachmentVersion(item) 
            {
                loadAttachmentVersion(item)
            },
            SaveDocumentAnnotations() 
            {
                SaveDocumentAnnotations();
            },
            openDocumentInWord() 
            {
                openFileInWord();
            },
            CheckOut() 
            {
                CheckOut();
                // if (viewer_enableShowStamps == true)
                //     this.showStamps=true;
                // else
                //     this.showStamps=false;
            },
            CheckIn() 
            {
                CheckIn();
                //this.showStamps=false;
            },
            DiscardCheckOut() 
            {
                DiscardCheckOut();
                //this.showStamps=false;
            },
            goToFirstPage() {
                goToFirstPage()
            },
            goToLastPage() {
                goToLastPage()
            },
            refreshPage() {
                refreshPage();
            },
            onDownload() {
                onDownload();
            },
            onDownloadWithAnnotations(){
                onDownloadWithAnnotations();
            },
            GetLogs() {
                GetLogs();
            },
            onPrint() {
                onPrint();
            },
            chooseImage() {
                this.$refs.fileInput.click()
            },
            onSelectFile() {
                const input = this.$refs.fileInput
                const files = input.files
                if (files && files[0]) {
                    const reader = new FileReader
                    reader.onload = e => {
                        this.imageData = e.target.result
                    }
                    reader.readAsDataURL(files[0])
                    this.$emit('input', files[0])
                }
            },
            onSelectStampFile() {
                const input = this.$refs.fileInputStamp
                const files = input.files
                if (files && files[0]) {
                    const reader = new FileReader
                    reader.onload = e => {
                        this.imageStampData = e.target.result
                    }
                    reader.readAsDataURL(files[0])
                    this.$emit('input', files[0])
                }
            },
            setScaleChange(selectedValue) {
                scaleSelectValue(selectedValue);
            },
            GetViewerLogs() {
                const axios_client = axios.create({
                    timeout: 50000,
                });
                var headers = {
                    'Authorization': 'Bearer ' + getUrlParameter('token')
                }
                itemId = getUrlParameter('id');
                axios.get(constants.ViewerActionUrl + "GetAttachmentLogs?Id=" + itemId, { headers: headers })
                    .then(response => {
                        this.itemst = response.data.map((item) => {
                            return {
                                details: {},
                                ...item
                            }
                        })
                        this.totalRecords = this.itemst.length;
                        this.pageCount = this.totalRecords / this.itemsPerPage;
                    })
            },
            toolbar_click(action_name) {
                switch (action_name) {
                    case 'download_withoutAnnotations':
                        onDownload();
                        break;
                    case 'download_withAnnotations':
                        onDownloadWithAnnotations();
                        break;
                    case 'start_handwriting':
                        StartHandWritingClick();
                        break;
                    case 'stop_handwriting':
                        StopHandWritingClick();
                        break;
                    case 'clear_handwriting':
                        ClearHandWritingClick();
                        break;
                    case 'clear_all_handwriting':
                        ClearAllWritingOnCanvas();
                        break;
                    case 'show_signatures':
                        ManageSignatures_Click();
                        break;

                    case 'annotate_blackout':
                        LoadStamp('./includes/images/hide.png');
                        break;
                    case 'annotate_highlight':
                        LoadHighlight();
                        break;
                    case 'annotate_note':
                        LoadNote();
                        break;

                    case 'annotate_approved_stamp':
                        LoadStamp('./includes/stamps/approved.png');
                        break;
                    case 'annotate_confidential_stamp':
                        LoadStamp('./includes/stamps/confidential.png');
                        break;
                    case 'annotate_draft_stamp':
                        LoadStamp('./includes/stamps/draft.png');
                        break;
                    case 'annotate_final_version_stamp':
                        LoadStamp('./includes/stamps/final_version.png');
                        break;
                    case 'annotate_reviewed_stamp':
                        LoadStamp('./includes/stamps/reviewed.png');
                        break;
                    case 'annotate_revised_stamp':
                        LoadStamp('./includes/stamps/revised.png');
                        break;
                }
            },
            showInformation(heading, text, continueHandler, cancelHandler) {
                this.information_heading = heading;
                this.information_text = text;
                this.information_continueHandler = continueHandler;
                this.information_cancelHandler = cancelHandler;
                this.informationDialog = true;
            },
            informationDialogOk() {
                this.informationDialog = false;
                this.information_continueHandler();
            },
            informationDialogCancel() {
                this.informationDialog = false;
                this.information_cancelHandler();
            },
            showHideLoading(isShow) {
                this.showLoader = isShow;
            },
            showAlert(msg, type) {
                this.snackbar_text = this.translate(msg);
                this.snackbar_type = type;
                this.snackbar_show = true;
                setTimeout(() => {
                    this.snackbar_show = false;
                }, 3000);
            },
            translate(text) {
                if (this.$i18n.locale == 'en')
                    return this.$i18n._getMessages().en[text] == null ? text : this.$i18n._getMessages().en[text]
                else
                    return this.$i18n._getMessages().ar[text] == null ? text : this.$i18n._getMessages().ar[text]
            },
            registerPDFRenderedEvent() {
                var selfRef = this;
                document.addEventListener('pagerendered', function (e) {
                    if (selfRef.defaultScale && !selfRef.pagerenderedAlreadyCalled) {
                        selfRef.setScaleChange(selfRef.defaultScale);
                    }

                    selfRef.pagerenderedAlreadyCalled = true;
                });
            },
            downloadEditor(){
                //
                document.getElementById("executableContainer").click();
            }
        }
   
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
  @import '../assets/css/stamp.css';
</style>
<style scoped>

    .paging #nextBtn {
        width: 36px;
        height: 36px !important;
        position: absolute;
        z-index: 1;
        bottom: 3rem;
        right: 0;
        background: #455664;
        border-radius: 50px;
        display: block;
    }

    .paging #previousBtn {
        width: 36px;
        height: 36px !important;
        position: absolute;
        z-index: 1;
        bottom: 3rem;
        left: 0;
        background: #455664;
        border-radius: 50px;
        display: block;
    }

    .dgs-new-button{
        background-color: #EBF1F6!important;
        color: #024976!important;
        text-align: center!important;
        font-family: ADNOC Sans;
        background-image: none!important;
        font-size: 14px!important;
        font-style: normal!important;
        font-weight: 500!important;
        line-height: normal!important;
        min-width: unset!important;
        letter-spacing: 0.14px!important;
    }
    .vue-tooltip-theme{
        z-index: 500;
        background: rgba(97,97,97,.9);
        color: #fff;
        border-radius: 4px;
        font-size: 14px;
        line-height: 22px;
        display: inline-block;
        padding: 5px 16px;
        position: absolute;
        text-transform: none;
        width: auto;
        opacity: 1;
        pointer-events: none;
    }

    .vue-tooltip-theme[x-placement*="bottom"] {
        top: 46px !important;
    }

    .bg-white{
        background-color:  #FFFFFF;
    }

    .stamp-items-wrapper {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }
</style>
